import React, { useState } from 'react';
import { BlockStack, Button, InlineStack, SkeletonBodyText, Text } from '@shopify/polaris';
import __helpers from 'helpers/index';
import { useGetOrderTransportLog } from 'queries/order_transport_log.query';
import 'media/css/order_transport_log.scss';
import { PlusIcon } from '@shopify/polaris-icons';
import ShowCreateTransportModal from './order_transport_modal';

export default function OrderTransportLog({ order_id }) {
  const { data, isLoading } = useGetOrderTransportLog(order_id);

  const [showTransactionModal, setShowTransactionModal] = useState(false);

  const ActualPage =
    !__helpers.isEmpty(data) &&
    data.map((element, index) => {
      return (
        <div className={`order_transport_history ${index === 0 && 'first_element'}`} key={`order_transport_history_${index}`}>
          <span className={`order_transport_history_item_dot order_transport_history_item_status_${element.transport_status}`}></span>
          <InlineStack align="start" blockAlign="center" gap="400">
            <div>{__helpers.subtractTimeHistory(Number(element.createdAt))}</div>
            <BlockStack>
              <Text as="h4" variant="headingMd">
                {element.transport_title}
              </Text>
              <Text as="p" variant="bodySm" tone="subdued">
                {element.transport_content}
              </Text>
            </BlockStack>
          </InlineStack>
        </div>
      );
    });

  return (
    <>
      <ShowCreateTransportModal current_order_id={order_id} show={showTransactionModal} onClose={() => setShowTransactionModal(false)} />

      {isLoading ? (
        <SkeletonBodyText />
      ) : (
        <BlockStack gap="400">
          <span>
            <Button icon={PlusIcon} onClick={() => setShowTransactionModal(true)}>
              Thêm nhật ký vận chuyển
            </Button>
          </span>
          <div id="order_transport_history_wrap">{ActualPage}</div>
          <Text as="p">Thông tin vận chuyển tại đây có thể được xem bởi khách hàng, trong các chức năng theo dõi đơn hàng.</Text>
        </BlockStack>
      )}
    </>
  );
}

